export default __webpack_public_path__ + "static/media/slide22.6b810805.png";